module.exports = __webpack_public_path__ + "img/87.9.TU.806b2eee.png";